import { uiSlice } from "./slice";

export const { setTheme, registerKeyPress, registerKeyRelease } =
	uiSlice.actions;
